var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"v-container-fluid",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"mt-5"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('p',{staticClass:"text-title mon-bold"},[_vm._v(" "+_vm._s(_vm.texts.disputes.textTitle)+" ")])])],1)],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }